import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { UserProfileDto, UserRole } from "@green0meter/api-client";

import { DOMAIN_FORMS } from "../domain";

import { formsApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_CREATE_FORM = "CREATE_FORM";

const allowedRoles = [UserRole.Owner, UserRole.Manager];

const unlockForm = async (formId: string): Promise<void> => {
  const response = await formsApi.formsControllerUnlockForm(formId);

  return response.data;
};

export const useUnlockForm = (
  user: UserProfileDto | null,
): {
  unlockForm: UseMutateFunction<void, Error, string, unknown>;
  unlockFormEnabled: boolean;
  isSuccessUnlockForm: boolean;
  isPendingUnlockForm: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isSuccess, isPending } = useMutation({
    mutationKey: [DOMAIN_FORMS],
    mutationFn: enabled ? unlockForm : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [DOMAIN_FORMS] });
    },
  });

  return {
    unlockForm: mutate,
    unlockFormEnabled: enabled,
    isSuccessUnlockForm: isSuccess,
    isPendingUnlockForm: isPending,
  };
};
